import getFilterFromRules from './getFilterFromRules';
import getRulesFromFilter from './getRulesFromFilter';
import type { FilterRule } from '@components/filter/types';

export const getFilterName = (filter) => filter.name;

export const getFilterKey = (filter, idx = -1) => {
  // TODO: add a fallback? worst case it will cause a forced re-render
  // shortId()
  const { name, meta = { cid: '-' } } = filter;
  return `${name}-${meta.cid}-${idx}`;
};

export const getOrderedRulesWithName = (filterRules: FilterRule[][]) => {
  const rules = getRulesFromFilter(filterRules, true);
  const tmpFilter = getFilterFromRules(rules, true);

  return tmpFilter as { name: string; rule: FilterRule[][] };
};
